<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $t("Signage Display List") }}</div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'Signages Display List')"
          variant="default"
          to="/signages/add-display"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div class="d-flex">
        <div class="col-lg-6 col-xl-7 align-self-center mb-2">
          <div class="dropdown-curve-container">
            <label
              :class="
                dropDown.cinemas && dropDown.cinemas.length > 0
                  ? 'shift-up'
                  : ''
              "
              >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
            >
            <multiselect
              :disabled="isRoleID"
              :options="dropDown.cinemas"
              v-model="dropDown.selectedCinema"
              :searchable="true"
              label="cine_name"
              track-by="cine_id"
              placeholder="Select Cinema"
              @input="onSelectCinema($event)"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
          </div>
        </div>

        <div class="col-lg-6 col-xl-7 align-self-center mb-3">
          <div class="dropdown-curve-container">
            <multiselect
              :options="dropdownstatus"
              track-by="id"
              v-model="selectedDropdownStatus"
              :searchable="true"
              label="name"
              placeholder="Filter By Status"
              :allowEmpty="false"
              :showLabels="false"
            ></multiselect>
          </div>
        </div>
      </div>

      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th>{{ $tc("Cinema Name", 1) }}</th>
          <th>{{ $tc("Display Name", 1) }}</th>
          <th>{{ $tc("Signage Url", 1) }}</th>
        </tr>
      </thead>
      <tbody v-if="SignageDisplayArray.length > 0">
        <tr v-for="(item, key) in SignageDisplayArray" :key="key">
          <!-- <td>
            <div class="d-flex align-items-center justify-content-start">
              <span @click="onClickStatusDot(item)">
                <StatusDot
                  :status="item.is_active == 'Y' ? 'active' : 'inactive'"
                />
              </span>
              <b-dropdown
                right
                variant="edit"
                class="ml-4"
                v-if="$can('update', 'Signages Display List')"
              >
                <b-dropdown-item
                  @click="goToRoute('/signages/edit-display/', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td> -->
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <span @click="onClickStatusDot(item)">
                <StatusDot
                  :status="item.is_active == 'Y' ? 'active' : 'inactive'"
                />
              </span>
              <i
                v-if="$can('update', 'Signages Display List')"
                class="edit-pen icon blue-icon cursor-pointer ml-4"
                @click.prevent.stop="goToRoute('/signages/edit-display/', item)"
                v-b-tooltip="'View Category'" tabindex="0"
              ></i>
            </div>
          </td>

          <td>{{ $tc(item.cine_name, 1) }}</td>
          <td>{{ item.display_name }}</td>
          <td>
            {{ signage_url + "?d=" + item.display_id + "&c=" + item.cinema_id }}
          </td>
        </tr>
      </tbody>
      <tbody v-if="SignageDisplayArray.length == 0">
        <tr>
          <td colspan="3">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="SignageDisplayArray.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>

    <b-modal
      id="confirmation_active_inactive"
      title="Confirmation"
      hide-footer
      hide-header
      centered
    >
      <div class="text-center pb-1 my-3">
        <p class="fs-16 mb-3">
          Are you sure you want to
          {{ selectedPop.is_active == "Y" ? "Inactive" : "Active" }} this
          Signage Display?
        </p>
        <span class="mx-1"></span>
        <button
          v-if="selectedPop.is_active == 'N'"
          class="btn btn-success btn-success-lg px-4 fs-14"
          @click.prevent.stop="UpdateStatus('Y')"
        >
          Active
        </button>
        <button
          v-else
          class="btn btn-danger btn-danger-lg px-4 fs-14"
          @click.prevent.stop="UpdateStatus('N')"
        >
          Inactive
        </button>
        <button
          class="btn-outline-blue"
          @click.prevent.stop="$bvModal.hide('confirmation_active_inactive')"
        >
          Cancel
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CurrenciesConversion from "@/helper/formJSONMaster/CurrenciesConversion";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";
import signageServices from "@/services/signageService";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      isRoleID: false,
      selectedPop: {
        display_id: null,
        pp_type_id: null,
        pp_name: "",
        pp_lang_id: null,
        pp_rating_type: "",
        pp_banner: "",
        pp_title: "",
        pp_country_id: "",
        pp_image_url: "",
        pp_description: "",
        is_active: "Y",
      },
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      dropdownstatus: [
        { id: 1, value: "", name: "All" },
        { id: 2, value: "Y", name: "Active" },
        { id: 3, value: "N", name: "Inactive" },
      ],
      selectedDropdownStatus: "",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      Methods: CurrenciesConversion.Methods,
      Currencies: [],
      viewingnumbers: [],
      customErrors: {
        message: "",
      },
      SignageDisplayArray: [],
      signage_url: "",
    };
  },
  watch: {
    selectedDropdownStatus(status) {
      this.selectedDropdownStatus = status;
      this.getSignageList();
    },
  },

  beforeMount() {
    let obj = this.secureStore.get("USINFO").cinema_id;

    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    if (CinemaObj) {
      this.selectedCinema = CinemaObj.cine_name;
      this.selected_cine_id = CinemaObj.cine_id;
      // this.getAllReturnGoods(CinemaObj.cine_id);
    }

    const { cinema_id } = this.secureStore.get("USINFO");

    this.getSignageList();
    this.getviewingnumber();
    this.getCinemaList(cinema_id);
  },

  methods: {
    onClickStatusDot(item) {
      this.selectedPop = _.cloneDeep(item);
      this.$bvModal.show("confirmation_active_inactive");
    },

    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        this.selectedvalue = event;
        this.perPage = event;
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getSignageList();
      } else {
        this.currentPage = event;
        this.getSignageList();
      }
    },
    goToRoute: function (path, item) {
      const { display_id } = item;
      this.$router.push({
        path: `${path}${display_id}`,
      });
    },

    UpdateStatus(status) {
      let loader = this.$loading.show();
      this.$bvModal.hide("confirmation_active_inactive");

      let payload = {
        display_id: this.selectedPop["display_id"],
        is_active: status
          ? status
          : this.selectedPop["is_active"] == "Y"
          ? "N"
          : "Y",
      };
      signageServices
        .UpdateSignageStatus(payload)
        .then((response) => {
          const { data } = response;
          this.getSignageList();
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          setTimeout(() => loader.hide(), 1000);
        });
    },

    getCinemaList: function (cinema_id) {
      MasterService.GetCinemas({cine_id: cinema_id})
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
      this.getSignageList();
    },

    getSignageList() {
      let loader = this.$loading.show();
      let selectedCinemaId = this.dropDown.selectedCinemaId;
      let payload = {
        cinema_id: selectedCinemaId,
        limit: this.perPage,
        currentPage: this.currentPage,
        is_active: this.selectedDropdownStatus.value,
      };
      this.SignageDisplayArray = [];
      signageServices
        .getDisplaySignage(payload)
        .then((response) => {
          const { data } = response;
          loader.hide();
          if (data.status) {
            if (
              data.Records.hasOwnProperty("data") &&
              data.Records.data.length > 0
            ) {
              this.SignageDisplayArray = data.Records.data;
              this.signage_url = data.signage_url;
              //   this.Currencies.map(x => {
              //     x["ccr_is_active"] = x["ccr_is_active"] == "Y" ? true : false;
              //   });

              if (this.currentPage == 1) {
                if (data.Records.pagination.total >= 10) {
                  this.rows = data.Records.pagination.total;
                } else {
                  this.rows = data.Records.pagination.total;
                  this.selectedvalue = data.Records.pagination.total;
                }
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {});
    },
    getCurrenciesList: function () {
      this.Currencies = [];
      let body = this.getRequestBody("GET", undefined, this.Methods);
      body.url += `?limit=${this.perPage}&currentPage=${this.currentPage}`;
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (
              data.Records.hasOwnProperty("data") &&
              data.Records.data.length > 0
            ) {
              this.Currencies = data.Records.data;
              this.Currencies.map((x) => {
                x["ccr_is_active"] = x["ccr_is_active"] == "Y" ? true : false;
              });

              if (data.Records.pagination.total >= 10) {
                this.rows = data.Records.pagination.total;
              } else {
                this.rows = data.Records.pagination.total;
                this.selectedvalue = data.Records.pagination.total;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>
<style scoped>
.text-white {
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/components/NewSignage/signage-display-list.vue